import { Account } from '@mkp/account/models';
import {
  AuthenticatedUserCategory,
  UserSourcePlatformType,
  UserTypeType,
  VisitorUserCategory,
} from '@mkp/tracking/models';
import { User, UserDisplayType } from '@mkp/user/models';
import { sha256 } from 'js-sha256';

export const getAuthenticatedUserCategory = (
  user: Pick<User, 'email' | 'id' | 'settings'>,
  account: Pick<Account, 'id' | 'legalEntity'> | null | undefined
): AuthenticatedUserCategory => ({
  user_id: sha256(user.email),
  user_login_id: user.id,
  user_account_id: account?.id,
  user_type: userDisplayTypeToUserType(user.settings.displayType),
  user_login_status: 'y',
  user_language: user.settings.language,
  user_source_platform: userDisplayTypeToSourcePlatform(user.settings.displayType),
});

export const getVisitorUserCategory = (): VisitorUserCategory => ({
  user_type: 'b2b',
  user_login_status: 'n',
});

/**
 * @param displayType can be null or undefined, if so, the function will return undefined.
 */
export const userDisplayTypeToSourcePlatform = (
  displayType: UserDisplayType | null | undefined
): UserSourcePlatformType | undefined => {
  const map: { [key in UserDisplayType]: UserSourcePlatformType } = {
    [UserDisplayType.CustomerJobs]: 'jobs',
    [UserDisplayType.CustomerJobUp]: 'jobup',
    [UserDisplayType.CustomerJobScout24]: 'jobscout24',
    [UserDisplayType.CustomerService]: 'service',
    [UserDisplayType.CustomerJobcloud]: 'jobcloud',
  };
  return displayType ? map[displayType] : undefined;
};

export const userDisplayTypeToUserType = (
  displayType: UserDisplayType | null | undefined
): UserTypeType | undefined => {
  switch (displayType) {
    case UserDisplayType.CustomerService:
      return 'backoffice';
    case UserDisplayType.CustomerJobcloud:
    case UserDisplayType.CustomerJobs:
    case UserDisplayType.CustomerJobUp:
    case UserDisplayType.CustomerJobScout24:
    default:
      return 'b2b';
  }
};
